import { render, staticRenderFns } from "./PaginationSimple.vue?vue&type=template&id=767d6ffb&"
import script from "./PaginationSimple.vue?vue&type=script&lang=js&"
export * from "./PaginationSimple.vue?vue&type=script&lang=js&"
import style0 from "./PaginationSimple.vue?vue&type=style&index=0&id=767d6ffb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports